var EnumValue = {
  print: function print(_ref) {
    var node = _ref.node;
    return node.name;
  }
};
module.exports = EnumValue;